import * as React from "react";
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import Typography from '@mui/material/Typography';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Button from "@mui/material/Button";
import CloseIcon from '@mui/icons-material/Close';
import PieChartIcon from '@mui/icons-material/PieChart';
import moment from "moment";
import CustomSelect from "../CustomComponents/CustomSelect";
import { dateTransformation } from '../../utils.js'
import { Link } from 'react-router-dom';
import {logger, customBodyForExcelReport,handleExport,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');
import { makeStyles } from "@mui/styles";
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import ReportTimeEntry from '../Reports/ReportTimeEntry';

export default function InvoiceBreakdown({ handleBreakdownCallback, data }) {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [ValueAlert, setAlert] = React.useState(false);
    const [alertText, setAlertText] = React.useState('');
    const [succeed, setSucceed] = React.useState(false);
    const [list, setList] = React.useState([])
    const [overTime, setsOverTime] = React.useState([])
    const [Discount, setDiscount] = React.useState([])
    const [discountNotAvailable, setDiscountNotAvailable] = React.useState(false);
    const [red, setRed] = React.useState(false);
    const startDate = moment.utc(data.StartDate).format("YYYY-MM-DD");
	const endDate = moment.utc(data.EndDate).format("YYYY-MM-DD");
	const [isLoading, setIsLoading] = React.useState(true);
    const handleAlertClose = () => {
        setAlert(false);
        setRefresh(true);
    };

    const handleClickOpen = () => {
        logger(data)
        logger(overTime)
        setRefresh(true)
        setOpen(true);
    };
    const onTrigger = React.useCallback(() => {
        handleBreakdownCallback();
    })

    const handleClose = () => {
        setOpen(false);
    };

    const applyDiscount = () => {
		var totalValue = 0;
		list.forEach((timeEntry, index) => {
			var price = getItemPrice(timeEntry);
			var dayOf = timeEntry.DayOf;
			var disc = 0;
			Discount.forEach((discount, index1) => {
				var start = discount.StartDate;
				var end = discount.EndDate;
				if (moment.utc(dayOf) >= moment.utc(start) && moment.utc(dayOf) <= moment.utc(end)) {
					disc = discount.Discount / 100;
					logger("disc", disc)
				}
			});
			
			totalValue += price - (price * disc);
		})
        
        logger(totalValue.toFixed(2));
        return totalValue.toFixed(2);
    }
  

	   const calculateRate = (rate, flagType) => {
	    if (overTime.length) {
	        if (flagType === 'OT') {
	            return (rate * overTime[0].OverTimeWeek).toFixed(2);
	        } else if (flagType === 'WND') {
	            return (rate * overTime[0].OverTimeWeekEnd).toFixed(2);
	        } else if (flagType === 'HOL') {
	            return (rate * overTime[0].OverTimeHoliday).toFixed(2);
	        } else {
	            return rate;
	        }
	    }
	};
    
    const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },

    },

}));
    const classes = pageStyles();

    const getTotal = () => {
        let total = 0
        list.map((item, index) => {
			const byteArray = new Uint8Array(item.Rate.data);
			const textDecoder = new TextDecoder();
			const res = textDecoder.decode(byteArray);
			const r = parseFloat(res).toFixed(2);
            total += calculateRate(r, item.FlagType) * item.Hours
        })
        return total.toFixed(2)
    };
    
    const getItemPrice = (item) => {
		const byteArray = new Uint8Array(item.Rate.data);
		const textDecoder = new TextDecoder();
		const res = textDecoder.decode(byteArray);
		const r = parseFloat(res).toFixed(2);
        return calculateRate(r, item.FlagType) * item.Hours;
    };

	
	const BillList = async () => {
						    const batchSize = 50;
						    const numBatches = Math.ceil(list.length / batchSize); 
						    for (let i = 0; i < numBatches; i++) {
						        const startIndex = i * batchSize;
						        const endIndex = Math.min(startIndex + batchSize, list.length);
						        const batchEntries = list.slice(startIndex, endIndex); 
						        const batchTimeEntryIDs = batchEntries.map(item => item.time_entryID); 
						
                                logger(`Updating invoices for batch ${i + 1}:`, batchTimeEntryIDs);
                                logger("api/invoice/list",{
                                    "InvoiceID": data.ID,
                                    "DiscountID": Discount[i]?.ID,
                                    "List": batchTimeEntryIDs
                                });
                                if(Discount.length===0){
									setDiscountNotAvailable(true);
									setAlertText(`There is no discunt available for the time period from ${moment.utc(data.StartDate).format("YYYY-MM-DD")} to ${moment.utc(data.EndDate).format("YYYY-MM-DD")}`);
									setAlert(true);
									return;
								}
						        try {
						            const response = await fetch("api/invoice/list", {
						                method: 'PATCH',
						                headers: { 'Content-Type': 'application/json' },
						                body: JSON.stringify({
                                            "InvoiceID": data.ID,
                                            "DiscountID": Discount[i].ID,
						                    "List": batchTimeEntryIDs
						                })
						            });
						
						            if (!response.ok) {
						                throw new Error(`Failed to update invoices for batch ${i + 1}`);
						            }
						        } catch (error) {
						            console.error(error);
						        }
						    }
						setRefresh(true);
						    setOpen(false);
						};


    const GetOverTime = async (sow) => {
        await fetch(`/api/SOW/OverTime/${sow}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => setsOverTime(json))
    };

    React.useEffect(() => {

        if (refresh) {
            if (data.IsBilled == 1) {
                fetch(`api/InvoiceBreakdown/${data.ID}`, {
                    method: 'Get',
                })
                    .then(res => res.json())
                    .then(json => {
                        logger("get invoices", json);
                        setList(json);
                        setIsLoading(false);
                        setRedStatus(json);
                        GetOverTime(json[0].SOWID)
                    })

                fetch(`/api/DiscountID/${data.DiscountID}`, {
                    method: 'Get',
                })
                    .then(res => res.json())
                    .then(json => setDiscount(json));
            } else {
                fetch(`api/Invoice/${data.POID}/${startDate}/${endDate}`, {
                    method: 'Get',
                })
                    .then(res => res.json())
                    .then(json => {
                        logger("get invoices", json);
                        setIsLoading(false);
                        setList(json);
                        setRedStatus(json);
						GetOverTime(json[0].SOWID)
					})
				fetch(`/api/Discount_Active/${moment.utc(data.StartDate).format("YYYY-MM-DD")}/${moment.utc(data.EndDate).format("YYYY-MM-DD")}`, {
					method: 'GET',
				})
					.then(res => res.json())
					.then(json =>
					{ setDiscount(json)
					logger("disount --", json)
					});
			}
			setRefresh(false);
		}
    })
	
	const setRedStatus = (json) => {
		let status = false;
		json.forEach(choice => {
			if (choice.RED === 1) {
				status = true;
			}
		})
		setRed(status);
	}

    const handleStatus = (status) => {
        if (status == 0) {
            return ("Pending");
        }
        if (status == 1) {
            return ("Approved");
        }
        if (status == -1) {
            return ("Rejected");
        }
    };

    const columns = [
        {
            name: "DayOf",
            label: "Day",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(list[dataIndex].DayOf).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "Name",
            label: "Name",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "position",
            label: "Position",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "Hours",
            label: "Hours",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div style={list[dataIndex].overTimeWarning ? { color: "red" } : {}}>
                            {list[dataIndex].Hours}
                        </div>
                    );
                }
            }
        },
        {
            name: "FlagType",
            label: "Flag Type",
            options: {
                filter: false,
                sort: true,
            }
        },

        {
            name: "Rate",
            label: "Rate",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
					if (list[dataIndex].Rate && list[dataIndex].FlagType)
					{
						const byteArray = new Uint8Array(list[dataIndex].Rate.data);
						const textDecoder = new TextDecoder();
						const res = textDecoder.decode(byteArray);
						const r = parseFloat(res).toFixed(2);    
			        return calculateRate(r, list[dataIndex].FlagType);
					    }
                    else{
						 console.log("Data is missing for calculation");
                        return (
                            <Tooltip title='Failing' className={classes.root}>
                                <ReportGmailerrorredIcon color='error' />
                            </Tooltip>
                        );
                        }
                }
            }
        },
		{
		    name: "VerifyStatus",
		    options: {
		        filter: false,
		        sort: false,
		        empty: true,
		        customBodyRenderLite: (dataIndex, rowIndex) => {
		            const overTimeWarningStyle = list[dataIndex].overTimeWarning ? { color: "red" } : {};
		            return (
		                <Tooltip title={list[dataIndex].overTimeWarning ? "Overtime Warning" : ""}>
		                    <div style={overTimeWarningStyle}>
		                        {handleStatus(list[dataIndex].VerifyStatus)}
		                    </div>
		                </Tooltip>
		            );
		        }
		    }
		},


 /*       {
            name: "Owner",
            label: "Bill To",
            options: {
                filter: false,
                sort: true,
                display: false,
            }
        },
        {
            name: "PO",
            label: "PO",
            options: {
                filter: false,
                sort: true,
                display: false,
            }
        }, */
        {
            name: "PoNumber",
            label: "PoNumber",
            options: {
                filter: false,
                sort: true,
                display: false,
            }
        },
        {
            name: "projectName",
            label: "Project",
            options: {
                filter: false,
                sort: true,
            }
        },
		{
		    name: "taskName",
		    label: "Task",
		    options: {
		        filter: false,
		        sort: true,
		        customBodyRenderLite: (dataIndex, rowIndex) => {
		            const redStyle = list[dataIndex].RED === 1 ? { color: "red" } : {};
		            return (
		                <div>
		                    <Tooltip title={list[dataIndex].RED ? "Check the L&P Dates" : ""}>
		                        <div style={redStyle} className={classes.root}>
		                            {list[dataIndex].taskName}
		                        </div>
		                    </Tooltip>
		                </div>
		            );
		        }
		    }
}


    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        rowsPerPage: initialRowsPerPage, // Use the initial value retrieved from local storage
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		 onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				logger("headers", headers);
				for (var i = 0; i < data.length; i++) {
					var eachRow = data[i].data;
					logger("eachrow", eachRow)
					var formatDate= eachRow[0];
					
					 var payRate = eachRow[5];
						 const byteArray = new Uint8Array(payRate.data);
						 const textDecoder = new TextDecoder();
						 const res = textDecoder.decode(byteArray);
						 const rate = parseFloat(res).toFixed(2);

						 eachRow[5] = calculateRate(rate, eachRow[4]);  
					
					 eachRow[0] = moment.utc(formatDate.data).format("MM/DD/YYYY");
					 eachRow[6] = handleStatus(eachRow[6]);
				 }
				 logger("headers and data after decrypt", headers, data);
				 return customBodyForExcelReport({ data: data, headers: headers });
			 };

			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			//handleExport({rows:rows, headers:headers, filename:'InvoiceBreakdown.xlsx'} )
			var add_date = true;
			var columnIndexToRemove = null;
			var numberOfColumnsToRemove = null;
			var filename = 'InvoiceBreakdown.xlsx';
			
			if (columnIndexToRemove !== null) {
				if (numberOfColumnsToRemove !== null) {
					headers.splice(columnIndexToRemove, numberOfColumnsToRemove);
				} else {
					headers.splice(columnIndexToRemove, 1);
				}
			}
			const workbook = new ExcelJS.Workbook();
			const worksheet = workbook.addWorksheet('Sheet 1');
		
			const headerRow = worksheet.addRow(headers);
			headerRow.font = { bold: true };
		
			rows.forEach((row, rowIndex) => {
			    const newRow = worksheet.addRow(Object.values(row));
			
			    worksheet.columns.forEach((col, colIndex) => {
			        const headerLength = col.header ? col.header.length : 0; // Handle header if undefined
			        var maxColumnWidth = col.values.reduce((maxWidth, value) => {
			            if (value && value.length > maxWidth) {
			                return value.length;
			            }
			            return maxWidth;
			        }, 0);
			
			        if (maxColumnWidth > 40) {
			            maxColumnWidth = 40;
			        }
					col.width = Math.max(headerLength, maxColumnWidth) + 2;
					col.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
					if (list[rowIndex]) {
						if (colIndex === 9 && list[rowIndex].RED === 1) {
							newRow.getCell(colIndex + 1).font = { color: { argb: 'eb4034' } };
						}
						if ((colIndex === 3 ||  colIndex === 6) && list[rowIndex].overTimeWarning) {
							newRow.getCell(colIndex + 1).font = { color: { argb: 'eb4034' } };
						}
					}
				});
			});
		
			const currentDate = moment.utc().format("yyyy-MM-DD");
			// Generate the Excel file
			workbook.xlsx.writeBuffer().then(buffer => {
				const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = add_date ? (currentDate + "_" + filename || currentDate + '_' + 'datatable.xlsx')
					: (filename || 'datatable.xlsx');
				a.click();
			});
			return false;
		},
        customToolbar: () => (
            <div>
            {(data.IsBilled===0 || data.IsBilled=== false) &&
                <Button variant="contained" style={ data.IsBilled? { color: "#fff" } : {}} onClick={() => {
                    if (list.filter(item => { return item.VerifyStatus === 1 && item.POActive===1}).length === list.length) {
                        setAlertText('Permanently assign these entries to this Invoice')
                        setAlert(true)
                        setSucceed(true)
                    } else {
						if(list.filter(item => { return (item.VerifyStatus === 0 || item.VerifyStatus === -1) && item.POActive === 1}).length >0){
							setAlertText('Permanently cannot assign these entries to this Invoice yet');
							setSucceed(false)
						}else{
							setAlertText('PO Expired , Please select New Active PO');
							setSucceed(true)
						}
                        setAlert(true)
                    }
                }}>
                    Bill List
                </Button>
                }
            </div>
            )
    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <div>
            <Tooltip title="Details" placement="top-end">
            <IconButton variant="contained" onClick={handleClickOpen}>
                <PieChartIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullScreen>
                <DialogContent>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                    <MuiThemeProvider theme={muiThemeDesign}>
                    <Box style={{ minHeight: '100vh' }}>
                        <MUIDataTable className="invoiceTable"
                            title={
                                <Typography variant="h6" style={{ color: "white"}}>
                <div><div><b>Invoice:</b> {data.InvoiceNumber} <b>PO:</b> {data.PO} <b>  StartDate:</b> {moment.utc(data.StartDate).format("MM/DD/YYYY")}
                                        <b>  EndDate:</b> {moment.utc(data.EndDate).format("MM/DD/YYYY")} </div><div> RAW total:${getTotal()}  Discounted total:${applyDiscount()} </div></div>
                                </Typography>
                            }
                            data={isLoading ? [] :list}
                            columns={columns}
                            options={muiLoaderOptions(options, isLoading)}

                        />
                        </Box>
                    </MuiThemeProvider>
                </DialogContent>
                <Dialog
                    open={ValueAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Bill Invoice"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {alertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                         <Button disabled={succeed && !red}><ReportTimeEntry start={moment.utc(data.StartDate).format('YYYY-MM-DD')} end={moment.utc(data.EndDate).format('YYYY-MM-DD')} poid={data.POID} /> </Button>
                        <Button onClick={() => { setAlert(false); setRefresh(true); setDiscountNotAvailable(false); }}>Cancel</Button>
                        <Button disabled={!succeed || discountNotAvailable} onClick={() => {
                            setAlert(false);
                            BillList();
                            onTrigger();
                        }} autoFocus>
                            ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </Dialog>
        </div>
    );
}